// T-306 — opposition à la prospection : client HTTP de la fiche client. Le tenant vient de la SESSION côté serveur.
// Les écritures portent l'en-tête anti-CSRF et un corps JSON ; le navigateur pose l'Origin tout seul.
import { getTenantHeaders } from "../../lib/utils";
import { ENTETE_CSRF, ErreurApi } from "../omnihub/communication/bureauAmoApi";

const API = process.env.REACT_APP_BACKEND_URL || "";
export const BASE = `${API}/api/metier/prospection`;

async function appeler(chemin, { methode = "GET", corps } = {}) {
  const post = methode !== "GET";
  const rep = await fetch(`${BASE}${chemin}`, {
    method: methode,
    credentials: "include",
    headers: getTenantHeaders(post ? { "Content-Type": "application/json", [ENTETE_CSRF]: "1" } : {}),
    ...(post ? { body: JSON.stringify(corps ?? {}) } : {}),
  });
  let json = null;
  try { json = await rep.json(); } catch { json = null; }
  if (!rep.ok) throw new ErreurApi(rep.status, json?.detail ?? "Erreur");
  return json;
}

export const etatProspection = (clientId) => appeler(`/clients/${encodeURIComponent(clientId)}`);
// `source` : fiche_client · telephone · courrier (le serveur refuse toute autre valeur).
export const poserOpposition = (clientId, source) => appeler(`/clients/${encodeURIComponent(clientId)}`, { methode: "POST", corps: { active: true, source } });
export const leverOpposition = (clientId) => appeler(`/clients/${encodeURIComponent(clientId)}`, { methode: "POST", corps: { active: false, source: "fiche_client" } });
